var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrameFootball = function SvgFrameFootball(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 235 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#frame-football_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221,
    height: 48,
    x: 7,
    y: 5,
    fill: "url(#frame-football_svg__b)",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 51,
    x: 5.5,
    y: 3.5,
    stroke: "url(#frame-football_svg__c)",
    strokeWidth: 3,
    rx: 9.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "frame-football_svg__b",
    x1: 117.5,
    x2: 117.5,
    y1: 5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1552F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C83C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frame-football_svg__c",
    x1: 117.5,
    x2: 117.5,
    y1: 5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0893CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#10C7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#067483"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "frame-football_svg__a",
    width: 235,
    height: 62,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_937_852",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0207959 0 0 0 0 0.0698317 0 0 0 0 0.511154 0 0 0 0.69 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_937_852"
  })))));
};
export default SvgFrameFootball;